








































import { Vue, Component, Prop } from 'vue-property-decorator';
import { EButtonType } from '@getaccept/lib-ui';
import { Twilio, ETwilioAction } from '@signing-page/integrations/twilio/store/twilio.constants';
import { IRecipient } from '@signing-page/documents/types/recipient';
import { testMobileNumber } from '@lib-shared/helpers';
import PhoneNumberInput from '@lib-shared/components/PhoneNumberInput.vue';
import { IEntity } from '@signing-page/entity/types/entity';

@Component({
  data: () => ({
    EButtonType,
  }),
  components: {
    PhoneNumberInput,
  },
})
export default class PhoneModal extends Vue {
  @Twilio.State('callSid') callSid: string;
  @Twilio.State('error') error: string;
  @Twilio.State('loading') loading: boolean;
  @Twilio.Action(ETwilioAction.CallPhone) callPhone: any;
  @Twilio.Action(ETwilioAction.CancelCall) cancelCall: any;

  @Prop() recipient: IRecipient;
  @Prop() entity: IEntity;

  phoneInputError = '';
  phoneNumber = '';

  get calling(): boolean {
    return !!this.callSid;
  }

  get callButtonDisabled(): boolean {
    return !this.phoneNumber || !!this.phoneInputError || this.calling;
  }

  handlePhoneInput(value: string) {
    this.phoneNumber = value;
    if (!testMobileNumber(value)) {
      this.phoneInputError = 'enter-a-valid-phone-number';
    } else {
      this.phoneInputError = '';
    }
  }

  handleClose() {
    this.$emit('close');
  }

  handleCancelCall() {
    this.cancelCall();
  }

  handleCallPhone() {
    this.callPhone(this.phoneNumber);
  }

  mounted() {
    this.phoneNumber = this.recipient?.mobile || '';
  }
}
